module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-profitability-forecasting-b508d0c6899bff48a9eda9e8a31243f3.png";